var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Link } from '@ambiguous/link';
import qDocumentsCategoriesTop from '@assets/gql/documents.categories.top.gql';
import { useQuery } from '@apollo/client';
import client from '@gql/client';
import React, { useEffect, useState } from 'react';
import gqlDocumentsList from '@assets/gql/documents.list.gql';
import gqlAttributes from '@assets/gql/documents.attributes.gql';
import { Content, Filters } from '@assets/tsx/list';
import { SearchControl } from "@assets/tsx/searchControl";
import { Modal } from '@assets/tsx/modal';
import OutsideAlerter from '@assets/tsx/outsideClicker';
import Heading from '@widgets/heading/heading';
import { EmailSubmit } from '@assets/tsx/emailSubmit';
import { Checkbox } from '@assets/tsx/checkbox';
import { AlertCard } from '@assets/tsx/alert';
import { isValidEmail } from '@assets/ts/emailValidate';
import Turnstile from 'react-turnstile';
import ActiveFilters from '@assets/tsx/activeFilters/ActiveFilters';
import SidebarModal, { SidebarControllers } from '@assets/tsx/sidebarModal/SidebarModal';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import { useLang } from '@ambiguous/useLang';
import { useI18n } from '@wordpress/react-i18n';
export default function Documents({ _id, attributes, categories, show_empty, show_subscription, show_attributes, prefetch }) {
    var _a;
    const [wrap, setWrap] = useState();
    const [checkedFilters, setCheckedFilters] = useState([]);
    const [toggleMenu, setToggleMenu] = useState(false);
    const [filters, setFilters] = useState({});
    const [filtersArr, setFiltersArr] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState({ field: 'ID', taxonomy: 'DOKUMENTOKATEGORIJA', terms: categories === null || categories === void 0 ? void 0 : categories.map((c) => c.toString()) });
    const [specificCategory, setSpecificCategory] = useState();
    const [search, setSearch] = useState('');
    const [showSubscription, setShowSubscription] = useState(false);
    const hide_filters = show_attributes === 'no' || (show_attributes === 'custom' && ((_a = attributes === null || attributes === void 0 ? void 0 : attributes.checked) === null || _a === void 0 ? void 0 : _a.length) == 0);
    const [lang] = useLang();
    const { __ } = useI18n();
    const { data: attrData } = useQuery(gqlAttributes, {
        client,
        variables: {
            include: (attributes === null || attributes === void 0 ? void 0 : attributes.checked) || [],
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        },
        skip: hide_filters
    });
    useEffect(() => {
        if (hide_filters === true) {
            setFiltersArr([]);
            setFilters({});
        }
    }, [hide_filters]);
    const labels = getLabels(filters);
    useEffect(() => {
        setCategoryFilter(prev => (Object.assign(Object.assign({}, prev), { terms: categories === null || categories === void 0 ? void 0 : categories.map(c => c.toString()) })));
    }, [categories]);
    useEffect(() => {
        if (!attrData)
            return;
        const checkedArr = attrData.terms.nodes.filter(f => checkedFilters.includes(f.databaseId));
        const filterMap = {};
        for (const attribute of checkedArr) {
            const { taxonomyEnumValue, databaseId } = attribute;
            if (!filterMap[taxonomyEnumValue]) {
                filterMap[taxonomyEnumValue] = [];
            }
            filterMap[taxonomyEnumValue].push(databaseId.toString());
        }
        const filterVar = Object.keys(filterMap).reduce((agr, fenum) => [...agr, { taxonomy: fenum, terms: filterMap[fenum], field: 'ID', operator: 'IN' }], []);
        setFiltersArr(filterVar);
    }, [checkedFilters, attrData]);
    useEffect(() => {
        if (!attrData)
            return;
        const flat = attrData.terms.nodes;
        const labeled = flat.reduce((agr, curr) => {
            var _a;
            const prevAttributes = !!agr[curr.taxonomyEnumValue] ? (_a = agr[curr.taxonomyEnumValue]) === null || _a === void 0 ? void 0 : _a.attributes : [];
            if (+curr.count === 0 && show_empty !== 'yes')
                return agr;
            if ((attributes === null || attributes === void 0 ? void 0 : attributes.hidden) && attributes.hidden.includes(curr.taxonomyEnumValue))
                return agr;
            return Object.assign(Object.assign({}, agr), { [curr.taxonomyEnumValue]: {
                    label: curr.taxonomyLabel,
                    attributes: [
                        ...prevAttributes,
                        curr
                    ]
                } });
        }, {});
        setFilters(labeled);
    }, [attrData, show_empty, attributes === null || attributes === void 0 ? void 0 : attributes.hidden]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: hide_filters ? 'ltg-list--no-filters' : "ltg-list documents-responsive-layout", ref: setWrap },
            React.createElement("div", null, Object.keys(filters).length > 0 && (React.createElement("div", { className: "documents-responsive-filters" }, Object.keys(filters).length > 0 && React.createElement(Filters, { checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters, filters: filters })))),
            React.createElement(SidebarModal, { open: toggleMenu },
                React.createElement(OutsideAlerter, { className: 'ltg-modal-sidebar-wrap', callback: () => {
                        setToggleMenu(false);
                    } },
                    React.createElement(SidebarControllers, { isFilters: true, handleCloseMenu: () => {
                            setToggleMenu(false);
                        }, handleClearFilters: () => {
                            setCheckedFilters([]);
                        } }),
                    React.createElement("div", null, filters &&
                        React.createElement(Filters, { filters: filters, checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters })))),
            React.createElement("div", { className: "ltg-list-wrap" },
                React.createElement("div", { className: 'ltg-list-wrap-top ltg-documents-controls-wrap documents-responsive-controls' },
                    React.createElement(SearchControl, { value: search, onChange: (newVal) => { setSearch(newVal); }, placeholder: __("Įveskite dokumento pavadinimą", "ltg-widgets") }),
                    show_subscription === 'yes' && (React.createElement("button", { role: 'button', onClick: () => { setShowSubscription(true); }, className: "btn btn-black ltg-list-wrap-top-btn" }, __("Prenumeruoti", 'ltg-widgets')))),
                Object.keys(filters).length > 0 &&
                    React.createElement(ActiveFilters, { filters: checkedFilters, labels: labels, visible: false, setCheckedFilters: setCheckedFilters, toggleMenu: () => {
                            setToggleMenu(true);
                        } }),
                React.createElement(DocumentsList, { search: search, filtersArr: filtersArr, categoryFilter: categoryFilter, specificCategory: specificCategory, setSpecificCategory: setSpecificCategory, wrap: wrap }))),
        show_subscription === 'yes' && (React.createElement(Modal, { open: showSubscription },
            React.createElement(OutsideAlerter, { callback: () => { setShowSubscription(false); } },
                React.createElement(DocumentsSubscription, { categories: categories, submitUrl: prefetch === null || prefetch === void 0 ? void 0 : prefetch.subscription_submit_url, onCloseModal: () => { setShowSubscription(false); }, turnstile_sitekey: prefetch === null || prefetch === void 0 ? void 0 : prefetch.turnstile_sitekey, id: _id }))))));
}
const DocumentsSubscription = (props) => {
    var _a, _b;
    const [checkedCats, setCheckedCats] = useState([]);
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [response, setResponse] = useState(null);
    const [token, setToken] = useState(null);
    const [lang] = useLang();
    const { __ } = useI18n();
    const { data, loading } = useQuery(qDocumentsCategoriesTop, {
        client,
        variables: {
            include: ((_a = props.categories) === null || _a === void 0 ? void 0 : _a.length) === 0 ? [] : props.categories,
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        }
    });
    const onSubmit = (ev) => __awaiter(void 0, void 0, void 0, function* () {
        ev.preventDefault();
        if (submitting)
            return;
        if (!email) {
            setError(__("Įveskite el. pašto adresą", 'ltg-widgets'));
            return;
        }
        if (!isValidEmail(email)) {
            setError(__("Netinkamas el. pašto formatas", 'ltg-widgets'));
            return;
        }
        setSubmitting(true);
        const formData = new FormData();
        checkedCats === null || checkedCats === void 0 ? void 0 : checkedCats.map((dbId) => {
            formData.append('checked[]', dbId);
        });
        formData.append('email', email);
        formData.append('cf-turnstile-response', token);
        const fetch_data = yield fetch(props === null || props === void 0 ? void 0 : props.submitUrl, { method: 'POST', body: formData }).then(res => res.json());
        setSubmitting(false);
        setResponse(fetch_data);
    });
    const categoryBoxes = (_b = data === null || data === void 0 ? void 0 : data.dokumentoKategorijos) === null || _b === void 0 ? void 0 : _b.nodes;
    if (response !== null) {
        return React.createElement(AlertCard, { onConfirm: props.onCloseModal, status: response === null || response === void 0 ? void 0 : response.status, title: response === null || response === void 0 ? void 0 : response.title, message: response === null || response === void 0 ? void 0 : response.message });
    }
    return React.createElement("div", { className: "ltg-documents-subscription-wrap" },
        React.createElement("div", { className: "text-right" },
            React.createElement("button", { onClick: () => { props.onCloseModal(); }, style: { border: 0 } },
                React.createElement("i", { className: "fas fa-times text-primary" }))),
        loading ? (React.createElement("h1", { role: "presentation", style: { padding: 32 } }, "Kraunasi...")) : (React.createElement("form", { onSubmit: onSubmit, noValidate: true },
            React.createElement(Heading, { underline: 'yes', text: __('Gaukite aktualiausią informaciją', "ltg-widgets") }),
            React.createElement(Heading, { tag: 'h4', text: __('Pažymėkite kategorijas', "ltg-widgets") }),
            (categoryBoxes === null || categoryBoxes === void 0 ? void 0 : categoryBoxes.length) !== 0 && (React.createElement("div", { style: { padding: '1rem 0' } }, categoryBoxes === null || categoryBoxes === void 0 ? void 0 : categoryBoxes.map(cat => {
                return React.createElement("div", { key: cat.id, style: { padding: '.5rem 0' } },
                    React.createElement(Checkbox, { label: cat.name, id: cat.id, checked: checkedCats.includes(cat.databaseId), onChange: () => setCheckedCats(prev => (prev.includes(cat.databaseId) ?
                            prev.filter(c => c !== cat.databaseId) :
                            [...prev, cat.databaseId])) }));
            }))),
            React.createElement(EmailSubmit, { id: props.id, text: __('Užsakyti', 'ltg-widgets'), value: email, placeholder: __('Jūsų el. pašto adresas', 'ltg-widgets'), onChange: (newVal) => {
                    setEmail(newVal);
                }, isSubmitting: false, error: error }),
            React.createElement("div", { style: { marginTop: 16, paddingLeft: 16 } },
                React.createElement(Turnstile, { onVerify: (token) => { setToken(token); }, sitekey: props === null || props === void 0 ? void 0 : props.turnstile_sitekey, autoResetOnExpire: true })))));
};
function DocumentsList({ search, filtersArr, categoryFilter, specificCategory, setSpecificCategory, wrap }) {
    var _a, _b, _c;
    const [list, setList] = useState([]);
    const perPage = 10;
    const [lang] = useLang();
    const { data, loading, refetch, fetchMore } = useQuery(gqlDocumentsList, {
        client,
        variables: {
            filters: parseFilters(filtersArr, categoryFilter, specificCategory),
            size: perPage,
            offset: 0,
            search,
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        },
    });
    const totalPosts = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.dokumentai) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.offsetPagination) === null || _c === void 0 ? void 0 : _c.total) || 0;
    const totalPages = Math.ceil(totalPosts / perPage);
    useEffect(() => {
        var _a;
        if (!data)
            return;
        setList(((_a = data === null || data === void 0 ? void 0 : data.dokumentai) === null || _a === void 0 ? void 0 : _a.edges) || []);
    }, [data]);
    const onClickPage = (page) => refetch({
        size: perPage,
        offset: perPage * page,
        filters: parseFilters(filtersArr, categoryFilter, specificCategory),
        search,
        language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
    }).then(() => {
        wrap && wrap.scrollIntoView({ behavior: 'smooth' });
    });
    const loadingTemplate = (props, index) => React.createElement(LoadingBox, { key: 'loader-' + index, style: { height: 85, marginBottom: 16 } });
    return (React.createElement(React.Fragment, null,
        !!(specificCategory === null || specificCategory === void 0 ? void 0 : specificCategory.name) && (React.createElement("h2", null,
            React.createElement("a", { href: "#", onClick: (ev) => { ev.preventDefault(); setSpecificCategory(null); } },
                React.createElement("i", { className: "fas fa-chevron-left", style: { marginRight: 15 } }),
                specificCategory.name))),
        React.createElement(Content, { onClickPage: onClickPage, itemTemplate: loading ? loadingTemplate : (item) => React.createElement(ListItem, { key: item.id, item: item }), list: loading ? new Array(perPage).fill({ node: 'loading' }) : list, loading: loading, totalPages: totalPages })));
}
function ListItem({ item }) {
    var _a;
    const { title, documentFields, dokumentoKategorijos } = item;
    const categories = dokumentoKategorijos === null || dokumentoKategorijos === void 0 ? void 0 : dokumentoKategorijos.nodes.reduce((agr, cat) => {
        var _a, _b;
        const ancestors = ((_b = (_a = cat === null || cat === void 0 ? void 0 : cat.ancestors) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.map(ancestor => ancestor.name)) || [];
        return [
            ...agr,
            ...ancestors,
            cat === null || cat === void 0 ? void 0 : cat.name
        ];
    }, []);
    return React.createElement(Link, { href: ((_a = documentFields === null || documentFields === void 0 ? void 0 : documentFields.dokumentas) === null || _a === void 0 ? void 0 : _a.url) || '#no-document-url', className: "ltg-list-item --document", target: '_blank' },
        React.createElement("div", null,
            React.createElement("div", { className: "ltg-list-item-title" }, title),
            (categories === null || categories === void 0 ? void 0 : categories.length) !== 0 && (React.createElement("small", { className: "ltg-list-item-categories text-muted" }, categories.join(', ')))));
}
function parseFilters(filtersArr, categoryFilter, specificCategory) {
    var _a;
    let filters = [];
    if ((filtersArr === null || filtersArr === void 0 ? void 0 : filtersArr.length) > 0) {
        filters = filters.concat(filtersArr);
    }
    if (specificCategory) {
        filters.push({
            field: 'ID',
            taxonomy: 'DOKUMENTOKATEGORIJA',
            terms: [`${specificCategory.id}`]
        });
    }
    else if (categoryFilter && ((_a = categoryFilter.terms) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        filters.push(categoryFilter);
    }
    if (filters.length > 0) {
        return filters;
    }
    return undefined;
}
function getLabels(filters) {
    const filterKeys = Object.keys(filters);
    const labelsArr = filterKeys.map((item) => {
        return filters[`${item}`].attributes;
    });
    let test = [];
    for (let i = 0; i < labelsArr.length; i++) {
        test = [...test, ...labelsArr[i]];
    }
    return {
        terms: {
            nodes: test
        }
    };
}
